// src/App.js
import React, { lazy, Suspense } from "react";
// react router
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { SpinnerDotted } from "spinners-react";
// components
import Layout from "./components/Layout";


// Eagerly load home (LCP page)
import HomePage from "./pages/HomePage/Home";

// Lazy load all other pages
const RoomsPage = lazy(() => import("./pages/RoomsPage"));
const RoomDetailsPage = lazy(() => import("./pages/RoomDetailsPage"));
const GlampingPage = lazy(() => import("./pages/GlampingPage"));
const HistoryPage = lazy(() => import("./pages/HistoryPage"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const Page404 = lazy(() => import("./pages/Page404"));
const FieldDayPage = lazy(() => import("./pages/FieldDayPage"));
const EventsPage = lazy(() => import("./pages/EventsPage/EventsPage"));
const ReservationPolicies = lazy(() => import("./pages/ReservationPolicies"));
const PackagesPage = lazy(() => import("./pages/PackagesPage"));
const PackageDetailsPage = lazy(() => import("./pages/PackageDetailsPage"));
const RestaurantPage = lazy(() => import("./pages/RestaurantPage"));
const ReservationConfirmation = lazy(() => import("./pages/ReservationConfirmation"));
const GiftCardPage = lazy(() => import("./pages/GiftCardPage"));
const MyGiftCards = lazy(() => import("./pages/MyGiftCards"));
const MyReservations = lazy(() => import("./pages/MyReservations"));
const FieldDayReservationDetail = lazy(() => import("./pages/FieldDayReservationDetail"));
const RestaurantReservationDetail = lazy(() => import("./pages/RestaurantReservationDetail"));
const MyProfile = lazy(() => import("./pages/MyProfile"));
const ActivateAccount = lazy(() => import("./pages/ActivateAccount"));
const ConfirmEmail = lazy(() => import("./pages/ConfirmEmail/ConfirmEmail"));
const ResetPassword = lazy(() => import("./pages/ResetPassword/ResetPassword"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe/Unsubscribe"));
const Satisfaction = lazy(() => import("./pages/Satisfaction"));

const LazyFallback = () => (
  <div className="min-h-screen flex justify-center items-center bg-white">
    <SpinnerDotted color="#a37d4c" />
  </div>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "hotel",
        element: <Suspense fallback={<LazyFallback />}><RoomsPage /></Suspense>,
      },
      {
        path: "room/:id",
        element: <Suspense fallback={<LazyFallback />}><RoomDetailsPage /></Suspense>,
      },
      {
        path: "glamping",
        element: <Suspense fallback={<LazyFallback />}><GlampingPage /></Suspense>,
      },
      {
        path: "servicios/diaDeCampo",
        element: <Suspense fallback={<LazyFallback />}><FieldDayPage /></Suspense>,
      },
      {
        path: "servicios/eventos",
        element: <Suspense fallback={<LazyFallback />}><EventsPage /></Suspense>,
      },
      {
        path: "servicios/restaurante",
        element: <Suspense fallback={<LazyFallback />}><RestaurantPage /></Suspense>,
      },
      {
        path: "historia",
        element: <Suspense fallback={<LazyFallback />}><HistoryPage /></Suspense>,
      },
      {
        path: "galeria",
        element: <Suspense fallback={<LazyFallback />}><GalleryPage /></Suspense>,
      },
      {
        path: "paquetes",
        element: <Suspense fallback={<LazyFallback />}><PackagesPage /></Suspense>,
      },
      {
        path: "paquetes/:id",
        element: <Suspense fallback={<LazyFallback />}><PackageDetailsPage /></Suspense>,
      },
      {
        path: "politicasDeReserva",
        element: <Suspense fallback={<LazyFallback />}><ReservationPolicies /></Suspense>,
      },
      {
        path: "gift-card",
        element: <Suspense fallback={<LazyFallback />}><GiftCardPage /></Suspense>,
      },
      {
        path: "reservation-confirmation/:id",
        element: <Suspense fallback={<LazyFallback />}><ReservationConfirmation /></Suspense>,
      },
      {
        path: "mis-reservas",
        element: <Suspense fallback={<LazyFallback />}><MyReservations /></Suspense>,
      },
      {
        path: "dia-de-campo/reserva/:id",
        element: <Suspense fallback={<LazyFallback />}><FieldDayReservationDetail /></Suspense>,
      },
      {
        path: "restaurante/reserva/:id",
        element: <Suspense fallback={<LazyFallback />}><RestaurantReservationDetail /></Suspense>,
      },
      {
        path: "mis-gift-cards",
        element: <Suspense fallback={<LazyFallback />}><MyGiftCards /></Suspense>,
      },
      {
        path: "mi-perfil",
        element: <Suspense fallback={<LazyFallback />}><MyProfile /></Suspense>,
      },
      {
        path: "activar-cuenta",
        element: <Suspense fallback={<LazyFallback />}><ActivateAccount /></Suspense>,
      },
      {
        path: "confirmar-email",
        element: <Suspense fallback={<LazyFallback />}><ConfirmEmail /></Suspense>,
      },
      {
        path: "restablecer-contrasena",
        element: <Suspense fallback={<LazyFallback />}><ResetPassword /></Suspense>,
      },
      {
        path: "baja",
        element: <Suspense fallback={<LazyFallback />}><Unsubscribe /></Suspense>,
      },
      {
        path: "encuesta/:token",
        element: <Suspense fallback={<LazyFallback />}><Satisfaction /></Suspense>,
      },
      {
        path: "api-test",
        element: <div>API Test no disponible</div>,
      },
      {
        path: "*", // Ruta para manejar URLs no encontradas
        element: <Suspense fallback={<LazyFallback />}><Page404 /></Suspense>,
      },
    ],
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
